import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "sr-only" }

import { useStore } from 'vuex';
import RichTranslation from '@shell/components/RichTranslation.vue';
import { RcIcon } from '@components/RcIcon';
import { useI18n } from '@shell/composables/useI18n';
import { getGitRepoRestrictionMigrationDocsUrl } from '@shell/utils/fleet-docs';


export default /*@__PURE__*/_defineComponent({
  __name: 'FleetMigrationGuideLink',
  setup(__props) {

const store = useStore();
const { t } = useI18n(store);

const migrationGuideUrl = getGitRepoRestrictionMigrationDocsUrl();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RichTranslation, {
    k: "fleet.restrictions.migrationGuide",
    tag: "div"
  }, {
    docsLink: _withCtx(({ content }) => [
      _createElementVNode("a", {
        href: _unref(migrationGuideUrl),
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        "data-testid": "fleet-migration-guide-link"
      }, [
        _createTextVNode(_toDisplayString(content) + " ", 1),
        _createVNode(_unref(RcIcon), {
          type: "external-link",
          size: "small",
          "aria-hidden": true
        }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('generic.opensInNewTab')), 1)
      ], 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})